/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";

// react-router components
import { useLocation, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import NotificationsIcon from "@mui/icons-material/Notifications";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";

// Dashboard components
import Modal from "@mui/material/Modal";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";

// Dashboard example components
import Breadcrumbs from "examples/Breadcrumbs";
import NotificationItem from "examples/Items/NotificationItem";

// import aiIcon from "../../../assets/chatbot.png";
import aiIcon from "../../../assets//chatbot2.png";

// import { IconButton } from "@mui/material";

// Custom styles for DashboardNavbar
import {
  navbarContainer,
  navbarIconButton,
  navbarRow,
} from "examples/Navbars/DashboardNavbar/styles";

// Dashboard context
import {
  setMiniSidenav,
  setOpenConfigurator,
  setTransparentNavbar,
  useMaterialUIController,
} from "context";

// Config file
import MDTypography from "components/MDTypography";

// Functions from store
import { getProfile, getSubModulesByRoleId } from "../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

function DashboardNavbar({
  absolute,
  light,
  isMini,
  previousPage,
  profileData,
  getProfile,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) {
  let user = cookies.get("loginDetailsForWMS");
  let jwtToken = user?.jwt;
  let roleId = user?.data?.roleId;
  let roleName = user?.data?.roleName;
  let userId = user?.data?.userId;
  let clientId = user?.data?.clientId;

  let email = user?.data?.email;

  // alert("email in :- "+email , "roleId ", roleId);

  useEffect(() => {
    getProfile(email, jwtToken);
  }, [getProfile]);

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let subscriptionAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "1bbd3d42-ffb2-4f7c-9691-ea8cc5ac4301",
  );

  let printerAccess = modulesData.find(
    (moduleId) => moduleId.moduleId == "a0a67b99-5b70-4989-9181-dfe1dcc50092",
  );

  let aiChatBotModule = modulesData
    ? modulesData.find(
        (moduleId) =>
          moduleId.parentModuleId == "c00bee27-4bf5-434a-8e2e-6c5748520f34",
      )
    : "";

  const [profileInfo, setProfileInfo] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let temp = profileData.profile ? profileData.profile : {};

    setLoading(profileData.loading);

    setProfileInfo(temp);
  }, [profileData]);

  const navigate = useNavigate();
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);

  const [notifOpen, setNotifOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const unreadCount = notifications.filter((n) => !n.status).length;

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar,
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 1 }}
    >
      <NotificationItem
        icon={<Icon>person</Icon>}
        title="User Profile"
        route="/profile"
      />
      {printerAccess && (
        <NotificationItem
          icon={<Icon>printer</Icon>}
          title="Printer Configurator"
          route="/printer-configurator"
        />
      )}

      <NotificationItem
        icon={<Icon>key</Icon>}
        title="Reset Password"
        route="/authentication/reset-password"
      />
      {/* <NotificationItem
        icon={<Icon>image</Icon>}
        title="Banner & Logo"
        route="/banner-logo"
      /> */}
      {subscriptionAccess && (
        <NotificationItem
          icon={<Icon>payment</Icon>}
          title="Subscription Plans"
          route="/subscription-plans"
        />
      )}
      {/* <NotificationItem
        icon={<Icon>support_agent</Icon>}
        title="AI Agent Support"
        route="/ai-agent-support"
      /> */}
      <NotificationItem
        icon={<Icon>call</Icon>}
        title="Contact Us"
        route="https://mobillor.com/contact-us"
        target="_blank"
      />
      <NotificationItem
        icon={<Icon>lock</Icon>}
        title="Logout"
        route="/authentication/logout"
      />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  // websocket implementation

  const notificationAccess = true;

  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [connected, setConnected] = useState(false);

  const wsRef = useRef(null);

  useEffect(() => {
    if (!notificationAccess) return;

    const url =
      window.location.protocol === "https:"
        ? "wss://10.1.2.115:1880/api/notifications2"
        : "ws://10.1.2.115:1880/api/notifications2";

    const ws = new WebSocket(url);
    wsRef.current = ws;

    ws.onopen = () => {
      setConnected(true);

      const once = {
        roleId,
        email,
        notificationId: "0",
      };
      ws.send(JSON.stringify(once));

      const id = setInterval(() => {
        if (ws.readyState === WebSocket.OPEN) {
          ws.send(
            JSON.stringify({
              roleId,
              email,
              notificationId: "0",
            }),
          );
        }
      }, 30000);
      ws._intervalId = id;
    };

    ws.onmessage = (e) => {
      try {
        const data = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if (data?.type === "markReadAck" && Array.isArray(data.ids)) {
          markLocalRead(data.ids);
          return;
        }
        const batch = Array.isArray(data) ? data : [data];
        setItems(batch);
      } catch {}
    };

    ws.onclose = () => {
      setConnected(false);
      if (ws._intervalId) clearInterval(ws._intervalId);
    };
    ws.onerror = () => setConnected(false);
    return () => {
      if (ws._intervalId) clearInterval(ws._intervalId);
      ws.close();
    };
  }, [notificationAccess, roleId, email]);

  const sendWs = (payload) => {
    const ws = wsRef.current;
    if (!ws || ws.readyState !== WebSocket.OPEN) return false;
    ws.send(JSON.stringify(payload));
    return true;
  };

  const onMarkRead = (id) => {
    markLocalRead([id]);
    const ok = sendWs({
      roleId: roleId,
      email: email,
      notificationId: id,
    });

    if (!ok) {
    }
  };

  const unreadCount1 = useMemo(
    () => items.filter((n) => !n.status).length,
    [items],
  );

  const markLocalRead = (ids) => {
    setItems((prev) =>
      prev.map((n) =>
        ids.includes(n.notificationId) ? { ...n, status: true } : n,
      ),
    );
  };
  // }
  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      // sx={(theme) =>
      //   navbar(theme, { transparentNavbar, absolute, light, darkMode })
      // }
      style={{
        marginBottom: "-26px",
        background: "white",
        borderRadius: "10px",
      }}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox
          color="inherit"
          mb={{ xs: 1, md: 0 }}
          sx={(theme) => navbarRow(theme, { isMini })}
          style={{ background: "white" }}
        >
          {previousPage && (
            <Tooltip title="Go To Previous Page">
              <MDButton
                color="primary"
                variant="contained"
                type="button"
                onClick={() => {
                  navigate(-1);
                }}
                size="small"
                iconOnly
                style={{
                  marginLeft: "-15px",
                  marginRight: "20px",
                  borderRadius: "5px",
                }}
              >
                <Icon>arrow_back_ios</Icon>
              </MDButton>
            </Tooltip>
          )}
          <MDBox style={{ background: "white" }}>
            <Breadcrumbs
              icon="home"
              title={route[route.length - 1]}
              route={route}
              light={light}
            />
          </MDBox>
        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            <MDBox color={light ? "white" : "inherit"}>
              {/* <Link to="/authentication/sign-in/basic">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Link> */}

              {/* <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                px={2}
                py={1}
                gap={2}
              >

              </MDBox> */}

              <MDBox display="flex" gap={2}>
                {aiChatBotModule && (
                  <Tooltip
                    title="MOBY"
                    sx={{ border: "1.2px solid", borderRadius: "5px" }}
                  >
                    <IconButton
                      color="info"
                      onClick={() => {
                        navigate("/ai-chat-bot", { state: { openChat: true } });
                      }}
                    >
                      {/* <SmartToyIcon /> */}
                      <img
                        src={aiIcon}
                        alt="Bot"
                        style={{ width: "20px", height: "auto" }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
                {notificationAccess && (
                  <div style={{ position: "relative" }}>
                    <Tooltip title={open ? "" : "View Notifications"} arrow>
                      <span>
                        <MDButton
                          variant="outlined"
                          color="info"
                          onClick={() => setOpen(true)}
                          style={{
                            position: "relative",
                            padding: "0",
                            borderRadius: 10,
                            lineHeight: 0,
                          }}
                        >
                          <NotificationsIcon
                            style={{ fontSize: 66, margin: "-2px 0" }}
                          />
                          {unreadCount1 > 0 && (
                            <span
                              style={{
                                position: "absolute",
                                top: -4,
                                right: -4,
                                minWidth: 18,
                                height: 18,
                                padding: "0 5px",
                                borderRadius: 9,
                                background: "#e53935",
                                color: "#fff",
                                fontSize: 11,
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 0 0 2px #fff",
                              }}
                            >
                              {unreadCount1 > 99 ? "99+" : unreadCount1}
                            </span>
                          )}
                        </MDButton>
                      </span>
                    </Tooltip>

                    <Modal open={open} onClose={() => setOpen(false)}>
                      <MDCard
                        sx={{
                          position: "fixed",
                          top: 64,
                          right: 24,
                          width: 400,
                          maxHeight: "70vh",
                          overflow: "hidden",
                          borderRadius: 2,
                          boxShadow: "0 12px 28px rgba(0,0,0,0.18)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "12px 16px",
                            borderBottom: "1px solid #eee",
                            background: "#fafafa",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 8,
                            }}
                          >
                            <span
                              style={{
                                width: 8,
                                height: 8,
                                borderRadius: 8,
                                background: connected ? "#27ae60" : "#e74c3c",
                              }}
                            />
                            <MDTypography variant="h6" style={{ margin: 0 }}>
                              Notifications
                            </MDTypography>
                            {unreadCount > 0 && (
                              <span
                                style={{
                                  marginLeft: 6,
                                  background: "#1976d2",
                                  color: "#fff",
                                  borderRadius: 10,
                                  padding: "2px 8px",
                                  fontSize: 12,
                                }}
                              >
                                {unreadCount} new
                              </span>
                            )}
                          </div>
                          <MDButton
                            size="small"
                            variant="text"
                            color="info"
                            onClick={() => setOpen(false)}
                          >
                            Close
                          </MDButton>
                        </div>

                        <div
                          style={{
                            overflowY: "auto",
                            maxHeight: "calc(70vh - 56px)",
                          }}
                        >
                          {items.length === 0 && (
                            <div
                              style={{
                                padding: 24,
                                color: "#666",
                                textAlign: "center",
                              }}
                            >
                              Nothing here yet
                            </div>
                          )}

                          {items.map((n) => (
                            <button
                              key={n.notificationId}
                              onClick={() => {}}
                              style={{
                                display: "flex",
                                width: "100%",
                                textAlign: "left",
                                border: "none",
                                background: "transparent",
                                padding: "12px 16px",
                                gap: 12,
                                borderBottom: "1px solid #f1f1f1",
                                cursor: "pointer",
                                position: "relative",
                                transition: "background 180ms",
                                backgroundColor: n.status
                                  ? "white"
                                  : "rgba(25, 118, 210, 0.06)",
                              }}
                            >
                              {!n.status && (
                                <span
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    bottom: 0,
                                    width: 3,
                                    background: "#1976d2",
                                  }}
                                />
                              )}

                              <div
                                style={{
                                  width: 36,
                                  height: 36,
                                  borderRadius: 8,
                                  background: "#eef3fb",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#1976d2",
                                  flexShrink: 0,
                                }}
                              >
                                🔔
                              </div>

                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div
                                  style={{
                                    fontWeight: 600,
                                    fontSize: 14,
                                    color: "#111",
                                    lineHeight: 1.3,
                                    marginBottom: 4,
                                  }}
                                >
                                  {n.message}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: 8,
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <span style={{ fontSize: 12, color: "#555" }}>
                                    Invoice #{n.invoiceId}
                                  </span>
                                  <span style={{ fontSize: 12, color: "#bbb" }}>
                                    •
                                  </span>
                                  <span style={{ fontSize: 12, color: "#777" }}>
                                    {new Date(n.createdAt).toLocaleString()}
                                  </span>
                                </div>
                              </div>

                              {!n.status ? (
                                <MDButton
                                  size="small"
                                  color="info"
                                  variant="text"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    onMarkRead(n.notificationId);
                                  }}
                                >
                                  Mark as read
                                </MDButton>
                              ) : (
                                <span style={{ fontSize: 12, color: "#888" }}>
                                  Read
                                </span>
                              )}
                            </button>
                          ))}
                        </div>

                        <div
                          style={{
                            padding: "8px 12px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            borderTop: "1px solid #eee",
                            background: "#fafafa",
                          }}
                        ></div>
                      </MDCard>
                    </Modal>
                  </div>
                )}
                <MDButton
                  variant="h3"
                  fontWeight="large"
                  color="black"
                  style={{
                    background: "white",
                    color: "grey",
                    fontSize: "15px",
                    marginTop: "-2.5px",
                  }}
                >
                  {profileInfo?.userName}
                </MDButton>
                <Tooltip title={miniSidenav ? "Open Sidebar" : "Close Sidebar"}>
                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}
                    onClick={handleMiniSidenav}
                    style={{ marginBottom: "0.28rem" }}
                  >
                    <Icon sx={iconsStyle}>
                      {miniSidenav ? "menu_open" : "menu"}
                    </Icon>
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title="Space Management Dashboard">
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                >
                  <MuiLink href={smUrl}>
                    <Icon sx={iconsStyle}>dashboard</Icon>
                  </MuiLink>
                </IconButton>
              </Tooltip> */}
                {/* <Tooltip title="Go To Editor">
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                >
                  <MuiLink href={mobillorUrl}>
                    <Icon sx={iconsStyle}>account_tree</Icon>
                  </MuiLink>
                </IconButton>
              </Tooltip> */}
                <Tooltip title="Account">
                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}
                    aria-controls="notification-menu"
                    aria-haspopup="true"
                    variant="contained"
                    onClick={handleOpenMenu}
                  >
                    <MDBox mb={0.3}>
                      <Icon sx={iconsStyle}>account_circle</Icon>
                    </MDBox>
                  </IconButton>
                </Tooltip>
                {/* <Tooltip title="Settings">
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={handleConfiguratorOpen}
                >
                  <MDBox mb={0.3}>
                    <Icon sx={iconsStyle}>settings</Icon>
                  </MDBox>
                </IconButton>
              </Tooltip> */}
              </MDBox>
              {renderMenu()}
            </MDBox>
          </MDBox>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    profileData: state.profile,
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getProfile: (email, jwtToken) => dispatch(getProfile(email, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(DashboardNavbar);
